import { useState } from "react";
import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import italyRegions from "@/data/italy-regions.json";

const ACCREDITED = {
  "Lazio": "ARES 118",
  "Lombardia": "AREU 118",
  "Sardegna": "AREUS 118",
  "Veneto": "SUEM 118",
  "Liguria": "118",
  "Piemonte": "118",
  "Basilicata": "118",
  "Calabria": "118",
  "Toscana": "118",
  "Marche": "118",
  "Abruzzo": "118",
  "Valle D'Aosta/Vallée D'Aoste": "118",
  "Friuli Venezia Giulia": "118",
};

const MARKERS = [
  { name: "Valle D'Aosta/Vallée D'Aoste", coordinates: [7.39, 45.73] },
  { name: "Piemonte", coordinates: [7.92, 45.06] },
  { name: "Lombardia", coordinates: [9.77, 45.62] },
  { name: "Friuli Venezia Giulia", coordinates: [13.06, 46.15] },
  { name: "Veneto", coordinates: [11.86, 45.65] },
  { name: "Liguria", coordinates: [8.7, 44.27] },
  { name: "Toscana", coordinates: [11.13, 43.45] },
  { name: "Marche", coordinates: [13.14, 43.35] },
  { name: "Lazio", coordinates: [12.77, 41.98] },
  { name: "Abruzzo", coordinates: [13.86, 42.23] },
  { name: "Basilicata", coordinates: [16.08, 40.5] },
  { name: "Calabria", coordinates: [16.35, 39.06] },
  { name: "Sardegna", coordinates: [9.03, 40.08] },
];

export const ItalyRegionsMap = () => {
  const [active, setActive] = useState(null);

  return (
    <div className="relative" data-testid="italy-regions-map">
      <div className="h-7 mb-2 text-xs uppercase tracking-[0.18em] text-brand-red font-bold">
        {active ? `${active.name} · ${ACCREDITED[active.name]}` : ""}
      </div>
      <ComposableMap
        projection="geoMercator"
        projectionConfig={{ center: [12.57, 41.55], scale: 2217 }}
        width={640}
        height={640}
        style={{ width: "100%", height: "auto", maxHeight: "560px" }}
      >
        <Geographies geography={italyRegions}>
          {({ geographies }) =>
            geographies.map((geo) => {
              const name = geo.properties.name;
              const isOn = Boolean(ACCREDITED[name]);
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={isOn ? "#D62828" : "#FAFAFA"}
                  stroke="#0A0A0A"
                  strokeWidth={0.6}
                  className={`outline-none transition-[fill] duration-200 ${
                    isOn ? "hover:fill-brand-reddark" : "hover:fill-zinc-200"
                  }`}
                />
              );
            })
          }
        </Geographies>
        {MARKERS.map((m) => (
          <Marker
            key={m.name}
            coordinates={m.coordinates}
            onMouseEnter={() => setActive(m)}
            onMouseLeave={() => setActive(null)}
            onClick={() => setActive(m)}
          >
            <circle r={7} fill="#D62828" opacity={0.25} />
            <circle r={3.5} fill="#D62828" stroke="#fff" strokeWidth={1.4} style={{ cursor: "pointer" }} />
          </Marker>
        ))}
      </ComposableMap>
      <div className="mt-2 flex flex-wrap gap-x-4 gap-y-1 text-[11px] uppercase tracking-[0.14em] text-brand-ink">
        <span className="inline-flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 rounded-full bg-brand-red inline-block" /> Accreditamento attivo
        </span>
        <span className="inline-flex items-center gap-1.5">
          <span className="w-2.5 h-2.5 border border-brand-black bg-brand-paper inline-block" /> In predisposizione
        </span>
      </div>
    </div>
  );
};
